/**
 * Size defines and processes the size(width/height) of the objects
 */
export class Size {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
}
